import React from 'react';
import exclamationIcon from '../../assets/images/exclamation-mark.png';
import executeIcon from '../../assets/images/execute.png';
import { CircularProgress } from '@mui/material'; // Add CircularProgress for the spinner
import styles from '../../css/common/confirmation-modal.module.css';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmationType?: 'delete' | 'execute';
  isProcessing?: boolean; // Prop to indicate loading state
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmationType = 'delete',
  isProcessing = false, // Default to false
}) => {
  if (!isOpen) return null;

  const iconSrc = confirmationType === 'execute' ? executeIcon : exclamationIcon;
  const confirmButtonStyle = confirmationType === 'execute' ? styles.executeConfirmButton : styles.deleteConfirmButton;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.modalContent}>
          <div className={styles.headerContainer}>
            <img src={iconSrc} alt="Confirmation Icon" className={styles.icon} />
            <h2 className={styles.header}>{title}</h2>
          </div>
          <p className={styles.text}>{message}</p>
          <div className={styles.buttonContainer}>
            <button
              onClick={onConfirm}
              className={`${styles.confirmButton} ${confirmButtonStyle}`}
              disabled={isProcessing} // Disable button when processing
            >
              {isProcessing ? (
                <CircularProgress size={20} color="inherit" /> // Display spinner in button
              ) : (
                'Confirm' // Regular label when not processing
              )}
            </button>
            <button
              onClick={onClose}
              className={styles.cancelButton}
              disabled={isProcessing} // Disable button when processing
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
